import type { TextInputProps } from '@mantine/core';
import { TextInput as MantineTextInput } from '@mantine/core';
import React from 'react';

import styles from './TextInput.module.css';

export const LBTextInput = React.forwardRef<
  React.ElementRef<typeof MantineTextInput>,
  TextInputProps
>((props, ref) => (
  <MantineTextInput
    ref={ref}
    classNames={styles}
    inputWrapperOrder={['label', 'input', 'error', 'description']}
    rightSectionPointerEvents='all'
    {...props}
  />
));
